import { render, staticRenderFns } from "./CustomCharacter.vue?vue&type=template&id=1aaed77b&scoped=true&"
import script from "./CustomCharacter.vue?vue&type=script&lang=js&"
export * from "./CustomCharacter.vue?vue&type=script&lang=js&"
import style0 from "./CustomCharacter.vue?vue&type=style&index=0&id=1aaed77b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaed77b",
  null
  
)

export default component.exports